import * as React from 'react';
import styled, { useTheme } from 'styled-components';

import useMediaQuery from '@/utils/useMediaQuery';

import { InteractiveIcon } from '../../icons/Icons';
import { DOCS_LINKS } from '../../utils';
import { InfoText } from '../global/InfoText';
import { ProductIllustration } from '../global/ProductIllustration';
import { FloatingText, Illustrations, Section } from '../global/sharedStyles';

const Wrapper = styled(Section)`
  .info-text {
    max-width: 360px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    .floating-text {
      position: absolute;
    }
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    .floating-text {
      position: static;
    }
  }
`;

const NoCodeIllustrations = styled(Illustrations)`
  height: 772px;
  margin-top: 20px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    height: auto;
    margin-top: 30px;
  }
`;

const TableCellIllustration = styled(ProductIllustration)`
  top: 0;
  right: -160px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    top: 0;
    right: -300px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;

    img {
      width: 100%;
    }
  }
`;

const PivotCellIllustration = styled(ProductIllustration)`
  top: 358px;
  left: 0;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    display: none;
  }
`;

const FilterCellIllustration = styled(ProductIllustration)`
  top: 584px;
  left: 600px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    display: none;
  }
`;

export const SectionNoCode: React.ComponentType = React.memo(() => {
  const theme = useTheme();
  const shouldCollapse = useMediaQuery(theme.mediaQueryString.MEDIUM);

  return (
    <Wrapper>
      <FloatingText>
        <InfoText
          description="Browse for data, explore it, and visualize it. Hex supports end-to-end data exploration without queries, code, or any technical requirements."
          icon={<InteractiveIcon />}
          link={DOCS_LINKS.Calculations}
          title="No code tools for everyone"
        />
      </FloatingText>
      <NoCodeIllustrations>
        <TableCellIllustration
          cellLabel="Table cell"
          hideHeader={shouldCollapse}
          imgPath="notebooks/table-cell"
        />
        <PivotCellIllustration
          cellLabel="Pivot cell"
          hideHeader={shouldCollapse}
          hideHeaderActions={true}
          imgPath="notebooks/pivot-cell"
        />
        <FilterCellIllustration
          cellLabel="Filter cell"
          hideHeader={true}
          imgPath="notebooks/filter-cell"
        />
      </NoCodeIllustrations>
    </Wrapper>
  );
});
